import { Alert, Flex } from 'antd';
import { t } from 'i18next';
import { AlertsProps } from '../interfaces';

export const Alerts = <EntityCrudData,>({ status, state, isUpdateChange, isUpdateImportChange }: AlertsProps<EntityCrudData>) => {
  return (
    <>
      {status === 'APPROVED' && (
        <Flex style={{ marginBottom: 8 }}>
          <Alert message={t('global.labels.changesWillVoidApproval')} type="warning" showIcon closable />
        </Flex>
      )}
      {(isUpdateChange || isUpdateImportChange) && (
        <Flex style={{ marginBottom: 8 }}>
          <Alert message={t('global.labels.changesWillBeImmediatelySaved')} type="warning" showIcon closable />
        </Flex>
      )}
      {state.dataSource && state.dataSource.length > 100 && (
        <Flex style={{ marginBottom: 8 }}>
          <Alert message={t('global.labels.moreThan100rowsSelected')} type="warning" showIcon closable />
        </Flex>
      )}
    </>
  );
};
